import { API_ROUTES } from '@/constants/apiRoutes';
import {
  InitiateAuthPayload,
  InitiateAuthResponse,
  AuthChallengeValidationPayload,
  AuthChallengeValidationResponse,
  ResetPasswordPaylod,
  ResetPasswordChallengeValidationPaylod,
  ResetPasswordChallengeValidationResponse,
  UpdatePasswordPayload,
  UpdatePasswordResponse,
  StartUpdateEmailPayload,
  UpdateEmailPayload,
  UpdateEmailResponse,
  StartUpdatePhoneNumberPayload,
  UpdatePhoneNumberPayload,
  ResetPasswordRequest,
} from '@/types/auth';
import { api } from '@/utils/api';

export const initateAuthRequest = async ({
  username,
  password,
  userGroup = 'teammate',
}: InitiateAuthPayload) => {
  const { data } = await api<InitiateAuthResponse>({
    url: API_ROUTES.INITIATE_AUTH,
    method: 'post',
    data: {
      username,
      password,
      user_group: userGroup,
    },
    isAuth: false,
    withCredentials: true,
  });

  return data;
};

export const authChallengeValidationRequest = async ({
  username,
  sms_mfa_code,
  session,
}: AuthChallengeValidationPayload) => {
  const { data } = await api<AuthChallengeValidationResponse>({
    url: API_ROUTES.AUTH_CHALLENGE_VALIDATION,
    method: 'post',
    data: {
      username,
      sms_mfa_code,
      session,
    },
    isAuth: false,
    withCredentials: true,
  });

  return data;
};

export const startResetPasswordRequest = async ({
  email,
  userGroup,
}: ResetPasswordPaylod) => {
  const { status } = await api({
    url: API_ROUTES.RESET_PASSWORD,
    method: 'post',
    data: {
      email,
      user_group: userGroup,
    },
    isAuth: false,
  });

  return status;
};

export const resetPasswordChallengeValidationRequest = async ({
  email,
  otp,
}: ResetPasswordChallengeValidationPaylod) => {
  const { data } = await api<ResetPasswordChallengeValidationResponse>({
    url: API_ROUTES.RESET_PASSWORD_CHALLENGE_VALIDATION,
    method: 'post',
    data: { email, otp_code: otp },
    isAuth: false,
  });

  return data;
};

export const resetPasswordRequest = async ({
  password,
  setPasswordCode,
}: ResetPasswordRequest) => {
  const { data } = await api<{ status: 'invalid' | 'valid' | 'expired' }>({
    url: API_ROUTES.RESET_PASSWORD_WEB,
    method: 'post',
    data: { password, set_password_code: setPasswordCode },
    isAuth: false,
  });

  return data;
};

export const updatePasswordRequest = async ({
  oldPassword,
  newPassword,
}: UpdatePasswordPayload) => {
  const { data } = await api<UpdatePasswordResponse>({
    url: API_ROUTES.UPDATE_PASSWORD,
    method: 'post',
    data: { old_password: oldPassword, new_password: newPassword },
  });

  return data;
};

export const startUpdateEmailRequest = async ({
  email,
}: StartUpdateEmailPayload) => {
  const { status } = await api({
    url: API_ROUTES.START_UPDATE_EMAIL,
    method: 'post',
    data: { email },
  });

  return status;
};

export const updateEmailRequest = async ({
  email,
  otp,
}: UpdateEmailPayload) => {
  const { data } = await api<UpdateEmailResponse>({
    url: API_ROUTES.UPDATE_EMAIL,
    method: 'post',
    data: { email, otp_code: otp },
  });

  return data;
};

export const startUpdatePhoneNumberRequest = async ({
  phoneNumber,
}: StartUpdatePhoneNumberPayload) => {
  const { status } = await api({
    url: API_ROUTES.START_UPDATE_PHONE_NUMBER,
    method: 'post',
    data: { phone_number: phoneNumber },
  });

  return status;
};

export const updatePhoneNumberRequest = async ({
  phoneNumber,
  otp,
}: UpdatePhoneNumberPayload) => {
  const { data } = await api<UpdateEmailResponse>({
    url: API_ROUTES.UPDATE_PHONE_NUMBER,
    method: 'post',
    data: { phone_number: phoneNumber, otp_code: otp },
  });

  return data;
};
